<template>
  <div class="pageContainer">
    <BannerComponent>
      <div class="bannerDiv">
        <button class="primaryButton" @click="performSpeedTest">Test My Speed</button>
        <div class="firewallWrapper">
          <h3>Firewall</h3>
          <CustomSwitch v-model="isOn"/>
        </div>
      </div>
    </BannerComponent>
    <div class="gaugesWrapper" v-if="speedData">
      <GaugeComponent
          icon="plus"
          title="Download"
          :min="speedData.downloadMin"
          :max="speedData.downloadMax"
          :value="speedData.downloadSpeed"
          :show-footer="true"
          value-label="MB/s"
          :small-value="true"
      />
      <GaugeComponent
          icon="plus"
          title="Upload"
          :min="speedData.uploadMin"
          :max="speedData.uploadMax"
          :value="speedData.uploadSpeed"
          :show-footer="true"
          value-label="MB/s"
          :small-value="true"
      />
    </div>
    <GaugeComponent
        icon="plus"
        title="Network Speed"
        :min="0"
        :max="100"
        :value="0"
        v-else
    />
<!--    <h4>Options:</h4>
    <div class="options">
      <button class="cardButton cardBackground">
        <font-awesome-icon class="plusIcon" :icon="['fas', 'plus']" />
      </button>
      <button class="cardButton cardBackground">
        <font-awesome-icon class="warningIcon" :icon="['fas', 'exclamation-triangle']" />
      </button>
      <button class="cardButton cardBackground"></button>
    </div>-->
    <h4>Current Networks:</h4>
    <div class="card cardBackground">
      <div class="cardContentWrapper" v-for="network of networks" v-bind:key="network.id">
        <h6>{{network.name}}</h6>
        <div class="lineDiv"></div>
      </div>
    </div>
    <button class="primaryButton" @click="goToStats">Metrics And Stats</button>
    <MessageModal :message="appMessage.text" :type="appMessage.type" ref="messageModal" />
    <LoadingPage :is-visible="loading"/>
  </div>
</template>

<script>
import {useLoginStore} from "@/stores/loginStore";
import MessageModal from "@/components/MessageModal.vue";
import BannerComponent from "@/components/BannerComponent.vue";
import CustomSwitch from "@/components/CustomSwitch.vue";
import GaugeComponent from "@/components/Gauge.vue";
import DeviceAPIService from "@/servicehandlers/DeviceAPIService";
import LoadingPage from "@/components/LoadingPage.vue";
const deviceAPIService = new DeviceAPIService()

export default {
  name: 'NetworkPage',
  components: {
    LoadingPage,
    GaugeComponent,
    CustomSwitch,
    BannerComponent,
    MessageModal,
  },
  data(){
    return {
      loading: false,
      appMessage: {
        text: '',
        type: 'error',
      },
      isOn: true,
      networks: [],
      speedData: null,
      deviceChecking: true,
    }
  },
  async mounted(){
    //console.clear()
    // Only 'device' users can access network functionality
    if (useLoginStore().getSubscriptionType === 'device') {
      this.deviceChecking = !useLoginStore().getDeviceOnline
      if (useLoginStore().getDeviceOnline) {
        await this.loadDeviceData()
      }
      this.startDeviceStatusWatcher()
    }
    // 'free' users handled by route guards/subscription service
  },
  computed: {
    isDeviceOnline() {
      return useLoginStore().getDeviceOnline
    }
  },
  watch: {
    isDeviceOnline(newValue) {
      if (newValue && this.deviceChecking) {
        this.deviceChecking = false
        this.loadDeviceData()
      } else if (!newValue) {
        this.deviceChecking = true
      }
    }
  },
  methods: {
    async loadDeviceData() {
      this.loading = true
      try {
        await this.getNetworks()
      } catch (e) {
        console.error('Error loading device data:', e)
      }
      this.loading = false
    },
    startDeviceStatusWatcher() {
      const checkInterval = setInterval(() => {
        if (useLoginStore().getSubscriptionType === 'device' && useLoginStore().getDeviceOnline && this.deviceChecking) {
          this.deviceChecking = false
          this.loadDeviceData()
          clearInterval(checkInterval)
        }
      }, 1000)
      
      setTimeout(() => {
        clearInterval(checkInterval)
        if (this.deviceChecking) {
          this.deviceChecking = false
        }
      }, 30000)
    },
    showError(e){
      this.appMessage.text = 'Error: ' + e
      this.appMessage.type = 'error'
      this.$refs.messageModal.open()
    },
    async getNetworks(){
      try {
        let response = await deviceAPIService.networkMetrics(this.$router, useLoginStore())
        console.log(response)
        for (let key of Object.keys(response.metrics)){
          console.log(key)
          let temp = {
            id: this.networks.length + 1,
            name: key === 'br0' ? 'WAN' : 'LAN',
          }
          this.networks.push(temp)
        }
      } catch (e) {
        this.showError(e)
      }
    },
    goToStats(){
      this.$router.push({
        name: 'networkStats'
      })
    },
    async performSpeedTest(){
      try {
        this.loading = true
        let response = await deviceAPIService.performSpeedTest(this.$router, useLoginStore())
        console.log(response)
        this.speedData = {
          downloadSpeed: response.download_mbps,
          uploadSpeed: response.upload_mbps,
          downloadMax: this.calculateMax(response.download_mbps),
          uploadMax: this.calculateMax(response.upload_mbps),
          downloadMin: 0,
          uploadMin: 0,
        }
        console.log(this.speedData)
        this.loading = false
      } catch (e) {
        this.showError(e)
        this.loading = false
      }
    },
    calculateMax(value){
      if (value < 100){
        return 100
      }
      return value
    },
  },
}
</script>

<style scoped>
.gaugesWrapper{
  display: flex;
  gap: 15px;
}
h6{
  text-align: left;
}
.plusIcon{
  color: var(--icon-green);
  font-size: 50px;
}
.warningIcon{
  color: var(--color-red-button);
  font-size: 50px;
}
h3{
  font-size: 20px;
  font-family: 'Oxanium', 'Inter', 'sans-serif';
  text-transform: uppercase;
}
.bannerDiv{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.firewallWrapper{
  display: flex;
  gap: 10px;
}
.options{
  display: flex;
  width: 100%;
  gap: 30px;
}
</style>